import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  fullWidth = false,
  children,
  style,
  disabled,
  ...props
}) => {
  const baseStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'center',
    minHeight: 'var(--nev-control-default-height, 48px)',
    padding: '10px var(--nev-space-6)',
    fontFamily: 'var(--nev-font-heading)',
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.4,
    borderRadius: 'var(--nev-radius-control)',
    border: '1px solid transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    width: fullWidth ? '100%' : 'auto',
    transition:
      'background-color var(--nev-duration-normal) ease, border-color var(--nev-duration-normal) ease',
    textDecoration: 'none',
  };

  let variantStyle: React.CSSProperties = {};

  if (variant === 'primary') {
    variantStyle = {
      backgroundColor: 'var(--nev-action-primary, var(--nev-color-lavender-800))',
      color: 'var(--nev-color-white)',
      borderColor: 'var(--nev-action-primary, var(--nev-color-lavender-800))',
    };
  } else if (variant === 'secondary') {
    variantStyle = {
      backgroundColor: 'var(--nev-action-secondary, var(--nev-color-olive-700))',
      color: 'var(--nev-color-white)',
      borderColor: 'var(--nev-action-secondary, var(--nev-color-olive-700))',
    };
  } else if (variant === 'outline') {
    variantStyle = {
      backgroundColor: 'transparent',
      color: 'var(--nev-text-primary)',
      borderColor: 'var(--nev-border-strong)',
    };
  }

  return (
    <button style={{ ...baseStyle, ...variantStyle, ...style }} disabled={disabled} {...props}>
      {children}
    </button>
  );
};
